<script>
  import { initializeApp } from 'firebase/app'
  import { getAuth, onAuthStateChanged } from 'firebase/auth'
  import { getFirestore } from 'firebase/firestore'
  import { firebaseConfig } from './helpers/firebaseConfig';
	import { Router, Route } from 'svelte-routing'
  import { setContext } from 'svelte'
  import axios from 'axios'
  import { subscribe } from './helpers/subscribe'
  import { pages } from './helpers/pages'
  import TopBar from './admin/components/TopBar.svelte'
  import { PageMarker } from './admin/helpers/pageMarker'
  import LeftMenuBar from './admin/components/LeftMenuBar.svelte'
  import RightColumn, { MobMenuHandler } from './admin/components/RightColumn.svelte'
  import Loader, { LoaderHandler } from './admin/components/Loader.svelte'
  import { ModalHandler } from './admin/components/Modal.svelte'
  import SnackBar, { SnackBarHandler } from './admin/components/SnackBar.svelte'

  export let authStore = subscribe()

  export let isAdmin = window.location.pathname.split('/')[1] == 'admin'

  if (window.location.pathname == '/politica-de-privacidade') {
    document.querySelector('body').classList.add('sem-fundo')
  }
  
  // Auth
  export const firebaseApp = initializeApp(firebaseConfig)
  export const auth = getAuth(firebaseApp)
  onAuthStateChanged(auth, (user) => {
    if (!isAdmin) return
    if (user) {
      authStore.set({
        user: {
          email: user.email,
          uid: user.uid,
          token: user.accessToken
        }
      })
      snackBarHandler.action('Você está logado', 3000)
      setTimeout(function() {
        loaderHandler.end()
      }, 1000);
    } else {
      authStore.set({user: false})
      setTimeout(function() {
        loaderHandler.end()
      }, 1000);
    }
  });

  const db = getFirestore(firebaseApp)
  setContext('db', db)

  export let pageMarker = new PageMarker()

  export let mobMenuHandler = new MobMenuHandler()

  export let loaderHandler = new LoaderHandler()
  export let loaderStore = loaderHandler.store()
  loaderHandler.init()

  export let snackBarHandler = new SnackBarHandler()
  export let snackBarStore = snackBarHandler.store()
  
  export let url = ''
  
  // Modal pages
  import LogIn from './admin/pages/LogIn.svelte'
  export let logInModal = new ModalHandler()

  // URL /confirma?e=guilherme.femoreiraasdasdsf@gmail.com&h=aecdd6bf92570a9a073240c50c96e5ae
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  if (urlParams.get('e') && urlParams.get('h')) {
    let dataConf = {
      confirma: true,
      email: urlParams.get('e'),
      hash: urlParams.get('h')
    }
    axios.post('https://qgoppzhdyb.execute-api.sa-east-1.amazonaws.com/default/bicsoleil_encontrinho', dataConf)
      .then(res => {
        snackBarHandler.action(res.data.msg, 4000, res.data.status)
      })
      .catch(error => {
        snackBarHandler.action(error, 4000, 'error')
      })
  }
</script>

{#if isAdmin && !$authStore.user}
  <LogIn
    {auth}
    modalHandler={logInModal}
  />
{/if}

{#if isAdmin}
  <Loader
    store={loaderStore}
    full={true}
  />
{/if}

<Router url="{url}">
  <div class="outter-container{!isAdmin ? ' main' : ''}">
    {#if isAdmin && $authStore.user}
      <LeftMenuBar
        {auth}
        {authStore}
        pageMarker={pageMarker}
        items={pages.menu}
      />
    {/if}
    <main class="main-content">
      {#if isAdmin && $authStore.user}
        <TopBar
          {authStore}
          mobMenuAction={mobMenuHandler.action.bind(mobMenuHandler)}
        />
      {/if}
      {#each pages.routes as page}
        {#if ($authStore.user && !page.public) || page.public}
          <Route
            {authStore}
            {snackBarHandler}
            path={page.path}
            component={page.component}
          />
        {/if}
      {/each}
    </main>
    {#if isAdmin && $authStore.user}
      <RightColumn
        {auth}
        {authStore}
        {pages}
        mobMenuHandler={mobMenuHandler}
        logInHandler={logInModal}
      />
    {/if}
  </div>

  {#if isAdmin}
    <!-- svelte-ignore css-unused-selector -->  
    <style lang="scss">
      @import './scss/media-sizes';
      @import './scss/grid';
      @import './scss/reset';
      @import './admin/scss/theme-light';
      @import './admin/scss/global';
      @import './admin/scss/datatables';
    </style>
  {:else}
    <!-- svelte-ignore css-unused-selector -->  
    <style lang="scss">
      @import './scss/media-sizes';
      @import './scss/grid';
      @import './scss/reset';
      @import './admin/scss/global';
    </style>
  {/if}
</Router>

<SnackBar
  store={snackBarStore}
/>